import React, { useCallback, useMemo } from 'react'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import Badge from '@/modules/base/components/badge/badge'
import lang from 'lang'
import clsx from 'clsx'
import theme from '@/theme'

const useStyles = makeStyles(() => ({
  item: {
    wordBreak: 'break-word',
    cursor: 'pointer',
    userSelect: 'none',
    padding: '10px 5px',
    borderBottom: theme.border,
    '&:hover': {
      '& $badge': {
        opacity: 1,
      },
      background: theme.rowHoverColor,
    },
    '&[data-selected=true]': {
      background: theme.rowHoverColor,
      cursor: 'default',
    },
  },
  badge: {
    cursor: 'pointer',
    display: 'inline',
    opacity: 0,
    marginLeft: 10,
    fontSize: 11,
    verticalAlign: 'middle',
    '& > *': {
      pointerEvents: 'none',
    },
    color: theme.primary,
    background: theme.white,
    border: theme.border,
    borderColor: theme.primary,
  },
  badgeIsDefault: {
    cursor: 'default',
    opacity: 1,
    background: theme.primary,
    color: theme.white,
  },
}))

function LetterPaperLayoutListItem(props) {
  const classes = useStyles()
  const { name, selected = false, isDefault, onSelect, onSetDefault, isOnboardingTester = false } = props
  const id = props.id ?? name

  const handleOnClick = useCallback((e) => {
    if (e.target.classList.contains(classes.badge)) {
      return onSetDefault && onSetDefault(id)
    }
    onSelect && onSelect(id)
  }, [id, onSelect, onSetDefault])

  const badge = !isOnboardingTester && useMemo(() => (<Badge
    label={isDefault ? lang.generics.default : lang.generics.setAsDefault}
    customClass={clsx(classes.badge, isDefault && classes.badgeIsDefault)}
  />), [isDefault])

  return (
    <li className={classes.item} data-selected={selected} data-id={id} onClick={handleOnClick}>
      <span>{lang.settings.letterPaperSettings.layout.types[name]}</span>{badge}
    </li>
  )
}
LetterPaperLayoutListItem.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  selected: PropTypes.bool,
  isDefault: PropTypes.bool,
  onSelect: PropTypes.func,
  onSetDefault: PropTypes.func,
}

export default LetterPaperLayoutListItem
